import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Recognizing the Pattern Without Blame",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t judge myself. I recognize a pattern — and stay with myself."
    ],
      [
      "Daily intention: Today I don’t judge myself. I recognize a pattern — and stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This is a pattern. Not a flaw in who I am.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This is a pattern. Not a flaw in who I am.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What type of people do I find myself attracted to again and again, even though it hurts?\n[Write here]",
      "What do these relationships have in common in hindsight?\n[Write here]",
      "What do I feel right now as I see this written down?\n[Write here]"
    ],
      [
      "What type of people do I find myself attracted to again and again, even though it hurts?\n[Write here]",
      "What do these relationships have in common in hindsight?\n[Write here]",
      "What do I feel right now as I see this written down?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A pattern is born from old pain. Today I simply see it."
    ],
      [
      "Closing",
      "A pattern is born from old pain. Today I simply see it."
    ]
    ),
    action: localizedGenderNode(
      "I write one sentence: “I am learning to understand myself, not to blame myself.”",
      "I write one sentence: “I am learning to understand myself, not to blame myself.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The Moment It Feels “Familiar”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice the sense of “home” that misleads me."
    ],
      [
      "Daily intention: Today I notice the sense of “home” that misleads me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does the strong attraction usually begin?\n[Write here]",
      "How does this “familiar” feeling show up in my body?\n[Write here]",
      "What do I mistakenly interpret as love?\n[Write here]"
    ],
      [
      "When does the strong attraction usually begin?\n[Write here]",
      "How does this “familiar” feeling show up in my body?\n[Write here]",
      "What do I mistakenly interpret as love?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Familiar does not always mean safe."
    ],
      [
      "Closing",
      "Familiar does not always mean safe."
    ]
    ),
    action: localizedGenderNode(
      "When a strong “spark” appears — one breath + the question: “Is this familiar, or is it good for me?”",
      "When a strong “spark” appears — one breath + the question: “Is this familiar, or is it good for me?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What I’m Trying to Fix Through the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I look at what I’m trying to heal through others."
    ],
      [
      "Daily intention: Today I look at what I’m trying to heal through others."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What old pain awakens in these relationships?\n[Write here]",
      "What do I hope will finally happen “this time”?\n[Write here]",
      "What am I trying to prove about myself?\n[Write here]"
    ],
      [
      "What old pain awakens in these relationships?\n[Write here]",
      "What do I hope will finally happen “this time”?\n[Write here]",
      "What am I trying to prove about myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A relationship is not meant to heal a wound — but to meet a whole person."
    ],
      [
      "Closing",
      "A relationship is not meant to heal a wound — but to meet a whole person."
    ]
    ),
    action: localizedGenderNode(
      "I write the sentence: “I don’t need to prove my worth through pain.”",
      "I write the sentence: “I don’t need to prove my worth through pain.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Intensity vs. Intimacy",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate drama from connection."
    ],
      [
      "Daily intention: Today I separate drama from connection."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does “intensity” look like in my relationships?\n[Write here]",
      "Where is there a lack of listening, stability, safety?\n[Write here]",
      "How do I imagine quiet intimacy?\n[Write here]"
    ],
      [
      "What does “intensity” look like in my relationships?\n[Write here]",
      "Where is there a lack of listening, stability, safety?\n[Write here]",
      "How do I imagine quiet intimacy?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Not every strong feeling is love."
    ],
      [
      "Closing",
      "Not every strong feeling is love."
    ]
    ),
    action: localizedGenderNode(
      "Today I notice one quiet moment — and don’t run from it.",
      "Today I notice one quiet moment — and don’t run from it."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Fear of Stability",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check whether calm scares me."
    ],
      [
      "Daily intention: Today I check whether calm scares me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I feel around a stable person?\n[Write here]",
      "What frightens me about a calm relationship?\n[Write here]",
      "What story do I tell myself about calm?\n[Write here]"
    ],
      [
      "How do I feel around a stable person?\n[Write here]",
      "What frightens me about a calm relationship?\n[Write here]",
      "What story do I tell myself about calm?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Calm does not mean emptiness. Sometimes it means safety."
    ],
      [
      "Closing",
      "Calm does not mean emptiness. Sometimes it means safety."
    ]
    ),
    action: localizedGenderNode(
      "I stay one more minute in a place that doesn’t “excite” me.",
      "I stay one more minute in a place that doesn’t “excite” me."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Boundaries That Break Too Early",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see when I give myself up."
    ],
      [
      "Daily intention: Today I see when I give myself up."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "At what point do I begin to give up a boundary?\n[Write here]",
      "What am I afraid will happen if I keep it?\n[Write here]",
      "How does this affect me later?\n[Write here]"
    ],
      [
      "At what point do I begin to give up a boundary?\n[Write here]",
      "What am I afraid will happen if I keep it?\n[Write here]",
      "How does this affect me later?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Attraction that doesn’t respect boundaries causes harm."
    ],
      [
      "Closing",
      "Attraction that doesn’t respect boundaries causes harm."
    ]
    ),
    action: localizedGenderNode(
      "I write down one boundary that mattered to me in the past.",
      "I write down one boundary that mattered to me in the past."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Pursuer–Avoider Pattern (If Present)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice an automatic movement."
    ],
      [
      "Daily intention: Today I notice an automatic movement."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Am I drawn to people who pull away?\n[Write here]",
      "What happens inside me when the other is emotionally unavailable?\n[Write here]",
      "What role do I take on there?\n[Write here]"
    ],
      [
      "Am I drawn to people who pull away?\n[Write here]",
      "What happens inside me when the other is emotionally unavailable?\n[Write here]",
      "What role do I take on there?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A pattern is a movement — not my identity."
    ],
      [
      "Closing",
      "A pattern is a movement — not my identity."
    ]
    ),
    action: localizedGenderNode(
      "When someone pulls away — I don’t chase immediately. I breathe.",
      "When someone pulls away — I don’t chase immediately. I breathe."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Who I Become Inside the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice who I am when I’m with them."
    ],
      [
      "Daily intention: Today I notice who I am when I’m with them."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I speak to myself in this kind of relationship?\n[Write here]",
      "Do I feel smaller, tense, confused?\n[Write here]",
      "Who do I want to be in a relationship?\n[Write here]"
    ],
      [
      "How do I speak to myself in this kind of relationship?\n[Write here]",
      "Do I feel smaller, tense, confused?\n[Write here]",
      "Who do I want to be in a relationship?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A relationship should expand me, not shrink me."
    ],
      [
      "Closing",
      "A relationship should expand me, not shrink me."
    ]
    ),
    action: localizedGenderNode(
      "I write one quality of myself that disappears in these relationships.",
      "I write one quality of myself that disappears in these relationships."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Fear of Abandonment Driving the Choice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fear without letting it choose for me."
    ],
      [
      "Daily intention: Today I touch the fear without letting it choose for me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my strongest fear about being alone?\n[Write here]",
      "How does it affect my choices?\n[Write here]",
      "What gentle truth exists even if the fear is there?\n[Write here]"
    ],
      [
      "What is my strongest fear about being alone?\n[Write here]",
      "How does it affect my choices?\n[Write here]",
      "What gentle truth exists even if the fear is there?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear is a feeling — not a compass."
    ],
      [
      "Closing",
      "Fear is a feeling — not a compass."
    ]
    ),
    action: localizedGenderNode(
      "I say: “Fear, I see you. I choose slowly.”",
      "I say: “Fear, I see you. I choose slowly.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "What I Truly Need in a Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I define needs, not fantasies."
    ],
      [
      "Daily intention: Today I define needs, not fantasies."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Three basic needs I have in a relationship:\n[Write here]",
      "Do they exist in the old pattern?\n[Write here]",
      "What matters more to me than excitement?\n[Write here]"
    ],
      [
      "Three basic needs I have in a relationship:\n[Write here]",
      "Do they exist in the old pattern?\n[Write here]",
      "What matters more to me than excitement?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Clear needs protect the heart."
    ],
      [
      "Closing",
      "Clear needs protect the heart."
    ]
    ),
    action: localizedGenderNode(
      "I keep my list of needs somewhere visible.",
      "I keep my list of needs somewhere visible."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Attraction as Pain, Not Destiny",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop believing “this is just how I am.”"
    ],
      [
      "Daily intention: Today I stop believing “this is just how I am.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What have I told myself about my attraction over the years?\n[Write here]",
      "How does it feel to imagine this is not fate?\n[Write here]",
      "What becomes possible if I learn to choose differently?\n[Write here]"
    ],
      [
      "What have I told myself about my attraction over the years?\n[Write here]",
      "How does it feel to imagine this is not fate?\n[Write here]",
      "What becomes possible if I learn to choose differently?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am not broken — I am learning."
    ],
      [
      "Closing",
      "I am not broken — I am learning."
    ]
    ),
    action: localizedGenderNode(
      "I replace one limiting sentence with a gentler one.",
      "I replace one limiting sentence with a gentler one."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Pausing Before the Next Choice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice slowing down."
    ],
      [
      "Daily intention: Today I practice slowing down."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I usually rush into relationships?\n[Write here]",
      "What happens if I wait a little longer?\n[Write here]",
      "Which red flag do I tend to ignore?\n[Write here]"
    ],
      [
      "How do I usually rush into relationships?\n[Write here]",
      "What happens if I wait a little longer?\n[Write here]",
      "Which red flag do I tend to ignore?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A good choice needs time."
    ],
      [
      "Closing",
      "A good choice needs time."
    ]
    ),
    action: localizedGenderNode(
      "Today I rush no emotional decision.",
      "Today I rush no emotional decision."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Building a New Kind of Attraction",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I define a different attraction."
    ],
      [
      "Daily intention: Today I define a different attraction."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What qualities do I want to be attracted to?\n[Write here]",
      "How does a relationship that respects me feel?\n[Write here]",
      "Which value will guide me from now on?\n[Write here]"
    ],
      [
      "What qualities do I want to be attracted to?\n[Write here]",
      "How does a relationship that respects me feel?\n[Write here]",
      "Which value will guide me from now on?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Attraction can be relearned."
    ],
      [
      "Closing",
      "Attraction can be relearned."
    ]
    ),
    action: localizedGenderNode(
      "I choose one value to carry this week.",
      "I choose one value to carry this week."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure and Commitment to Myself",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I summarize without judgment."
    ],
      [
      "Daily intention: Today I summarize without judgment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I understand about myself on this journey?\n[Write here]",
      "What do I stop doing in relationships?\n[Write here]",
      "A return sentence for days of confusion:\n[Write here]"
    ],
      [
      "What did I understand about myself on this journey?\n[Write here]",
      "What do I stop doing in relationships?\n[Write here]",
      "A return sentence for days of confusion:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I am not attracted to what harms me —",
      "I am learning to listen to what respects me.",
      "I continue walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I am not attracted to what harms me —",
      "I am learning to listen to what respects me.",
      "I continue walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes a new choice (writing / safe conversation / inner order).",
      "One action that symbolizes a new choice (writing / safe conversation / inner order)."
    ),
  },
].map(buildNormalizedDay);

export const repeatedAttractionToDestructivePartnersBlueprintEn = buildNormalizedPilotBlueprint({
  id: "repeated_attraction_to_destructive_partners_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "repeated_attraction_to_destructive_partners",
  category: "general",
  journeyName: {
    he: "משיכה חוזרת לבני/בנות זוג הרסניים",
    en: "Repeated Attraction to Destructive Partners",
    es: "Atracción Repetida por Parejas Destructivas",
  },
  days,
});

export default repeatedAttractionToDestructivePartnersBlueprintEn;
